
<template>
  <div>
    <!-- 面包屑导航 -->
    <el-breadcrumb separator-class="el-icon-arrow-right">
      <el-breadcrumb-item >管理</el-breadcrumb-item>
      <!-- :to="{ path: '/' }" -->
      <el-breadcrumb-item>热门队伍设置管理</el-breadcrumb-item>
    </el-breadcrumb>
    <!-- 搜索筛选 -->
    <div style="float: right;margin-right:2%;">
        <input placeholder="输入网点名称的关键字进行搜索" v-model="outlet" style='margin: 10px 0;'></input>
        <el-button style='margin: 10px 0;' size="mini" type="primary"
            icon="document" @click="dataSelect">搜索</el-button> 
            <!-- <el-button style='margin: 10px 0;' size="mini" type="primary"
            icon="document"><el-upload class="avatar-uploader" v-model="img"
             action="https://admin.shengqianxiong.com.cn/tao/upload" :show-file-list="false"
             :on-success="handleAvatarSuccess">新增</el-upload></el-button> -->
            <!-- <img v-if="img" :src="img" class="avatar"
              style="border-radius: 6px;width: 148px;height: 148px;" />
            <i v-else class="el-icon-plus avatar-uploader-icon"></i> -->
    </div>

    <el-table style="width:100%" border v-loading="tableDataLoading" :data="tableData" row-key="id" @selection-change="handleSelectionChange">
      <el-table-column
      type="selection"
      width="55">
      </el-table-column>
			<!-- <el-table-column  prop="id" label="编号" width="80">
			</el-table-column> -->
			<el-table-column align="center" prop="outlet" label="网点名称">
			</el-table-column>
      <el-table-column align="center" prop="business" label="业务名称">
			</el-table-column>
      <el-table-column align="center" prop="phone" label="联系电话">
			</el-table-column>
      <el-table-column align="center" prop="isDeleted" label="队伍是否删除">
        <template slot-scope="scope">
          <div v-if="scope.row.idDeleted">是</div>
          <div v-if="!scope.row.idDeleted">否</div>
        </template>
			</el-table-column>
      <el-table-column align="center" prop="sort" label="排序(越大越靠前,0或者负数不显示)">
        <template slot-scope="scope">
            <div v-if="scope.row.sort===null">无</div>
            <div v-if="scope.row.sort!==null">{{ scope.row.sort }}</div>
        </template>
      </el-table-column>
			
			<el-table-column align="center" label="操作" width="240px">
				<template slot-scope="scope">
					<el-button size="mini" type="primary"
						@click="openDialogFormVisible(scope.row)">更改序号
					</el-button>
				</template>
			</el-table-column>
		</el-table>

    <el-dialog title="热门队伍排序更改" :visible.sync="dialogFormVisible" center>
      <div style="margin-bottom: 10px;">
        <span style="width: 200px;display: inline-block;text-align: right;">排序码：</span>
        <el-input style="width:50%;" type="number" v-model="updateForm.sort" placeholder="请输入排序码"></el-input>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="releasNoticeTo()">添 加</el-button>
      </div>
    </el-dialog>


  </div>
</template>

<script>
import { getHotTeamList , deleteCarousel , getCarouselList } from '../../../api/manage/team.js'

import { addAdvertisingPackages , deleteAdvertisingPackages , getAdvertisingPackagesList , updateAdvertisingPackages } from '../../../api/manage/advertisingPackages.js'

import moment from 'moment';

export default {
  data() {
    return {
        outlet : '',
        multipleSelection: [],
        totalnum:0,
        page : 1 ,
        size : 10,
        tableDataLoading:false,
        dialogFormVisible:false,
        tableData:[],
       
        updateForm:{
            
        },

    }
  },
  components: {

  },

  created() {
    this.dataSelect()
    // this.getdata(1)
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },

    releasNoticeTo(){
        let post = addForm;
        addAdvertisingPackages(post).then((res) => {
            this.dialogFormVisible = false
            this.$message({
                type: "success",
                message: res.msg,
                duration: 1500,
                onClose: () => {
                    this.dataSelect()
                }
            });
        })

    },

    deletes(id){
      let obj = {
          id:id,
      }
      this.$confirm(`确定删除此条信息?`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        deleteAdvertisingPackages(obj).then(res => {
          this.$message({
            type: "success",
            message: res.msg,
            duration: 1500,
            onClose: () => {
              this.dataSelect()
            }
          });
        })
      }).catch(() => {})
    },

    dataSelect(){
      let post = {
        page : (this.page - 1 ) * this.size,
        size : this.size,
        outlet : this.outlet
      }
      this.tableDataLoading = true
      getHotTeamList(post).then((res) => {
        this.tableDataLoading = false
        if (res.code == 200) {
            // this.tableData = res.data.data;
            // res.data.data.forEach(item => {
            //   // console.log(item.createTime);
            //   item.createTime=moment(item.createTime).format('YYYY-MM-DD HH:mm:ss')
            //   // 
            // });
            this.tableData = res.data.list
            // console.log('this.tableDatathis.tableData',this.tableData)
            this.totalnum = res.data.count;
            return;
        }
        this.$message({
            type: "info",
            message: res.msg,
        });
    })

    },

     // 添加分类弹框
    openDialogFormVisible(row) {
        this.updateForm = row
        this.dialogFormVisible = true
    },

  }
}
</script>

<style scoped>
.userRole {
  width: 100%;

}
</style>


// WEBPACK FOOTER //
// src/views/manage/hotTeam/index.vue